module.exports = __webpack_public_path__ + "img/fork-road.3665c34.jpg";